module.exports = "\r\n<label [ngClass]=\"labelstyle\">{{label}}</label>\r\n\r\n<div [ngClass]=\"radiocontainerstyle\">\r\n    \r\n    <mat-radio-group [(ngModel)]=\"value\" [disabled]=\"disable\">\r\n        <mat-radio-button [value]=\"rg.value\" *ngFor=\"let rg of dataList\" (change)=\"onValueChange($event)\">\r\n            {{rg.viewValue}}\r\n        </mat-radio-button>\r\n    </mat-radio-group>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/radiobutton.control.html
// module id = ../../../../../client/app/shared/controls/radiobutton.control.html
// module chunks = main